import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AppProvider, useApp } from '@/context/AppContext';
import CyberHome from '@/pages/CyberHome';
import StoryBookHome from '@/pages/StoryBookHome';
import ScorePredictor from '@/pages/ScorePredictor';
import StudyPlan from '@/pages/StudyPlan';
import DailyQuestions from '@/pages/DailyQuestions';
import QuestionBank from '@/pages/QuestionBank';
import AuthPage from '@/pages/AuthPage';
import AuthCallback from '@/pages/AuthCallback';
import ChatBot from '@/components/ChatBot';
import TowersOfMastery from '@/pages/TowersOfMastery';
import AdminDashboard from '@/pages/AdminDashboard';
import usePageviewTracker from '@/hooks/usePageviewTracker';
import { Toaster } from 'sonner';

function HomeSwitch() {
  const { mode } = useApp();
  return mode === 'cyber' ? <CyberHome /> : <StoryBookHome />;
}

function ChatSwitch() {
  const { mode } = useApp();
  return <ChatBot bot={mode === 'cyber' ? 'pulse' : 'pixie'} />;
}

function AppRouter() {
  usePageviewTracker();
  const location = useLocation();
  if (location.hash?.includes('session_id=')) return <AuthCallback />;
  return (
    <>
      <Routes>
        <Route path="/" element={<HomeSwitch />} />
        <Route path="/predictor" element={<ScorePredictor />} />
        <Route path="/study-plan" element={<StudyPlan />} />
        <Route path="/daily" element={<DailyQuestions />} />
        <Route path="/bank" element={<QuestionBank />} />
        <Route path="/auth" element={<AuthPage />} />
        <Route path="/towers" element={<TowersOfMastery />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
      <ChatSwitch />
      <Toaster position="bottom-left" />
    </>
  );
}

export default function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </AppProvider>
  );
}
